import { useTranslation } from 'react-i18next';

export default function Testimonials() {
  const { t } = useTranslation();

  const reviews = [
    { nameKey: 'testimonial.1.name', handleKey: 'testimonial.1.handle', textKey: 'testimonial.1.text', color: 'bg-accent-100' },
    { nameKey: 'testimonial.2.name', handleKey: 'testimonial.2.handle', textKey: 'testimonial.2.text', color: 'bg-secondary-100' },
    { nameKey: 'testimonial.3.name', handleKey: 'testimonial.3.handle', textKey: 'testimonial.3.text', color: 'bg-primary-100' },
    { nameKey: 'testimonial.4.name', handleKey: 'testimonial.4.handle', textKey: 'testimonial.4.text', color: 'bg-secondary-100' },
    { nameKey: 'testimonial.5.name', handleKey: 'testimonial.5.handle', textKey: 'testimonial.5.text', color: 'bg-accent-100' },
    { nameKey: 'testimonial.6.name', handleKey: 'testimonial.6.handle', textKey: 'testimonial.6.text', color: 'bg-primary-100' },
  ];

  const leftColumn = [reviews[0], reviews[3]];
  const middleColumn = [reviews[1], reviews[4]];
  const rightColumn = [reviews[2], reviews[5]];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="inline-block px-3 py-1.5 bg-background-50 rounded-full text-xs font-medium text-foreground-600">
            {t('testimonials.label')}
          </span>
          <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 leading-[1.2]">
            {t('testimonials.title')}
            <br />
            {t('testimonials.title_line2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {[leftColumn, middleColumn, rightColumn].map((col, colIdx) => (
            <div key={colIdx} className="flex flex-col gap-4 md:gap-5">
              {col.map((review, reviewIdx) => (
                <div
                  key={reviewIdx}
                  className="bg-background-50 rounded-2xl p-5 md:p-6"
                >
                  <div className="flex items-center gap-3">
                    <div className={`w-10 h-10 rounded-full ${review.color} flex items-center justify-center text-foreground-700 font-semibold text-sm`}>
                      {t(review.nameKey).charAt(0)}
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">
                        {t(review.nameKey)}
                      </p>
                      <p className="text-xs text-foreground-500">
                        {t(review.handleKey)}
                      </p>
                    </div>
                  </div>
                  <p className="mt-4 text-sm text-foreground-700 leading-relaxed">
                    &ldquo;{t(review.textKey)}&rdquo;
                  </p>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}